// App.jsx
import React from 'react';
import Navigation from './components/Navigation.jsx';
import HeroSection from './components/HeroSection.jsx';
import AboutSection from './components/AboutSection.jsx';
import ServicesSection from './components/ServicesSection.jsx';
import PortfolioSection from './components/PortfolioSection.jsx';
 import cat from './assets/images/icons8-cat-footprint-96.png';
import Footer from './components/Footer.jsx';
import './App.css';

const CustomCursor = () => {
  const cursorRef = React.useRef(null);

  React.useEffect(() => {
    const moveCursor = (e) => {
      if (!cursorRef.current) return;
      const { clientX: x, clientY: y } = e;
      cursorRef.current.style.transform = `translate(${x - 20}px, ${y - 20}px)`;
    };

    window.addEventListener('mousemove', moveCursor);
    document.documentElement.style.cursor = 'none'; // hide default cursor

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      document.documentElement.style.cursor = 'auto';
    };
  }, []);

  return (
    <div
      ref={cursorRef}
      className="fixed pointer-events-none z-[9999] w-10 h-10 -translate-x-1/2 -translate-y-1/2 transition-transform duration-150 ease-out mix-blend-difference"
    >
      <img
        src={cat}
        alt="cursor"
        className="w-full h-full object-contain"
      />
    </div>
  );
};

const App = () => {
  return (
    <>
      <CustomCursor />

      <div className="min-h-screen bg-black relative overflow-x-hidden">
        <Navigation />

        <div className="pl-0 lg:pl-80 transition-all duration-300">
          <div id="hero">
            <HeroSection />
          </div>

          <div id="about">
            <AboutSection />
          </div>

          <div id="services">
            <ServicesSection />
          </div>

          <div id="portfolio">
            <PortfolioSection />
          </div>

          {/* <div id="contact">
            <ContactSection />
          </div> */}

          <Footer />
        </div>
      </div>
    </>
  );
};

export default App;